module.exports = __webpack_public_path__ + "static/img/image032.cb38aee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image032.png
// module id = 8EgG
// module chunks = 1